
import i18n from '@/i18n'
import { Component, Prop, Vue } from 'vue-property-decorator'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'
import { getIdLevel } from '@/utils/KeycloakUtils'

@Component({
  i18n,
  components: {
    TeaserAccountTile
  }
})
export default class PolicyInformationTile extends Vue {
  @Prop({ default: window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEINPUT_PAGE })
  private enterServiceCodeUrl!: string

  @Prop({ default: window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEREQUEST_PAGE })
  private misPlacedServiceCodeUrl!: string

  get showPolicyInformationTile(): boolean {
    return getIdLevel() === 0
  }
}
